<template>
  <span class="v-info">
    <v-menu
      v-model="shown"
      content-class="v-info"
      :overlay-opacity="0"
      :open-on-hover="$vuetify.breakpoint.mdAndUp"
      offset-y
      :top="top"
      :nudge-left="nudgeLeft"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          x-small
          :ripple="false"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon x-small>icon-Info</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title v-if="enableHeader"
                      class="info-title"
        >
          {{ header }}
        </v-card-title>
        <v-card class="info-body">
          <div class="body-text">
            {{ body }}
          </div>
        </v-card>
      </v-card>
    </v-menu>
  </span>
</template>

<script>

export default {
  name: "VcitaInfo",
  data() {
    return {
      shown: false
    }
  },
  created() {
    if (!this.$vuetify.breakpoint.mdAndUp) {
      document.body.addEventListener('click', () => {
        this.shown = false
      });
    }
  },
  props: {
    header: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: '',
      required: true
    },
    top: {
      type: Boolean,
      default: true
    },
    nudgeLeft: {
      type: Number,
    }
  },

  methods: {},
  computed: {
    enableHeader() {
      return this.header.length > 0
    }
  }
};
</script>


<style lang="scss">

@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.v-info {
  font-family: var(--primary-font-family);

  button.v-btn.v-btn--icon {
    color: rgba(0, 0, 0, 0.4);

    &::before {
      background-color: unset;
    }
  }

  &.v-menu__content {
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.06), 0px 3px 14px 2px rgba(0, 0, 0, 0.06);
    border-radius: 6px;

    .info-title {
      display: block;
      background: #E7F0FF;
      color: #478FFF;
      border-radius: 6px 6px 0 0;
      font-weight: 600;
      max-height: 44px;
      white-space: nowrap;
      line-height: 20px;
      font-size: 15px;
      padding: 12px 16px;
    }

    .info-body {
      display: block;
      font-size: 13px;
      padding: 12px 16px 16px;
      .body-text {
        max-width: fit-content;
        min-width: 250px;
        word-wrap: break-word;
      }
    }
  }

}
</style>
